module.exports = __webpack_public_path__ + "static/media/billingCycle.661a434a.svg";